import API from "../../restAPI";
const Api = new API();

export default class ForgotPassword {
  // send forgot password request
  forgotPasswordRequest(payload) {
    return Api.request("/forgot-password-request", payload, "POST");
  }

  // semd forgot password request
  verifyForgotPasswordCode(payload) {
    return Api.request("/verify-forgot-password-code", payload, "POST");
  }
}
